import type { SmsConsentSpec } from '@opendoor/auth-fe/forms';

/**
 * The tour sheet's marketing-SMS consent versions, keyed by the `consentLanguage`
 * value recorded with each opt-in so legal can resolve a consent row to the exact
 * copy the buyer saw.
 *
 * DO NOT EDIT AN EXISTING ENTRY. Recorded consents reference these keys, so new
 * copy means adding an entry and pointing `CURRENT_VERSION` at it.
 */
const TOUR_SMS_CONSENT_VERSIONS = {
  marketing_sms_tours_v1: {
    checkboxes: [
      {
        name: 'marketing-opt-in',
        description:
          'By checking this box, I agree to receive marketing calls and texts from Opendoor and its affiliates at the number above. Consent is not a condition of purchase. Message frequency varies. Message and data rates may apply. Reply HELP for help or STOP to cancel.',
        analyticsSuffix: 'marketing-opt-in',
        drivesPreference: true,
      },
    ],
  },
} as const satisfies Record<string, Omit<SmsConsentSpec, 'version'>>;

type TourSmsConsentVersion = keyof typeof TOUR_SMS_CONSENT_VERSIONS;

const CURRENT_VERSION: TourSmsConsentVersion = 'marketing_sms_tours_v1';

export const TOUR_SMS_CONSENT: SmsConsentSpec = {
  version: CURRENT_VERSION,
  ...TOUR_SMS_CONSENT_VERSIONS[CURRENT_VERSION],
};
